import { render, staticRenderFns } from "./approval_count.vue.js?vue&type=template&id=b1d7642c&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approval_count.vue?vue&type=template&id=b1d7642c&vue3"
import script from "./approval_count.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approval_count.vue?vue&type=script&lang=js&vue3"
export * from "./approval_count.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approval_count.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports